import {Injectable, signal} from '@angular/core';
import {PeriodRange} from '../../../components/period-navigator/period-navigator';

@Injectable()
export class FinancesPeriodStore {
  readonly period = signal<PeriodRange>(this._currentMonth());

  private _currentMonth(): PeriodRange {
    const now = new Date();
    return {
      startDate: new Date(Date.UTC(now.getFullYear(), now.getMonth(), 1)),
      endDate: new Date(Date.UTC(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999)),
    };
  }
}
